import React, { Component } from 'react';

import { AsyncSelect } from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';

import { Label } from '@qality/common-components';
import { AUTOMATED_EXECUTION_USER } from '@qality/common-components/src/picker/UserPicker';
import { IS_CLOUD } from '@qality/common-config';
import { UserService } from '@qality/common-service';
import { Utils } from '@qality/common-utils';

const ALL_USERS_OPTION = {
  label: 'All users',
  value: 'all',
};

type Props = {
  onChange: (selected: [{ name: string; value: string }]) => undefined;
  isDisabled: boolean;
  tooltip: string;
  userId?: string;
};

type State = {
  selectOptions: Array<any>;
  selectValue: any;
};

export default class UserSelect extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: [],
      selectValue: ALL_USERS_OPTION,
    };
  }

  async componentDidMount() {
    let users = await this.initOptions();
    if (!this.props.isDisabled) {
      users = await this.findUserFromUrl(users);
    }
    this.setState({
      selectOptions: users,
    });
  }

  // eslint-disable-next-line complexity
  findUserFromUrl = async (users: Array<any>) => {
    const { userId } = this.props;
    if (!Utils.isNilOrEmpty(userId) && userId !== ALL_USERS_OPTION.value) {
      let user = users.find((userItem) => userItem.value === userId);
      if (!user) {
        user = await UserService.retrieveUserSelectObjectById(userId);
        users.push(user);
      }
      if (user) {
        this.setState({
          selectValue: user,
        });
      }
    }
    return users;
  };

  initOptions = async () => {
    return await UserService.getUsersForPicker('', IS_CLOUD);
  };

  loadOptions = async (inputValue: string) => {
    return await UserService.getUsersForPicker(
      inputValue,
      IS_CLOUD &&
        AUTOMATED_EXECUTION_USER.label
          .toLocaleLowerCase()
          .includes(inputValue.toLocaleLowerCase())
    );
  };

  onChange = async (option: {
    label: string;
    value: string;
  }): Promise<void> => {
    const useFallbackValue = Utils.isNilOrEmpty(option);
    const selectedOption = useFallbackValue ? ALL_USERS_OPTION : option;

    this.setState({
      selectValue: selectedOption,
    });
    this.props.onChange([{ name: 'accountId', value: selectedOption.value }]);
  };

  render() {
    return (
      <div
        className='hide-focus-wrapper filter-common'
        style={{ width: '300px' }}
      >
        <Label text='User' />
        <Tooltip content={this.props.tooltip}>
          <div>
            <AsyncSelect
              id='qality-user-picker'
              isDisabled={this.props.isDisabled}
              className='user-select'
              classNamePrefix='solkit'
              defaultOptions={this.state.selectOptions}
              loadOptions={this.loadOptions}
              placeholder='Search user...'
              onChange={this.onChange}
              isClearable={true}
              value={this.state.selectValue}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
